// Test (staging) deployment — Cloudflare Pages, built by the deploy_to_test
// job in .github/workflows/frontend.yaml. Optimized like production, but with
// source maps so a failing screen can be traced back to real code.
export const environment = {
  production: true,
  // The public API gateway, not the cluster ingress. Two reasons it has to be
  // this one: esmsapi.testingress.senkron.energy resolves to 100.64.1.52, which
  // is CGNAT space and unreachable from a browser outside the VPN — and Pages
  // serves static files only, so there is no same-origin /api proxy to fall
  // back on (that is the nginx.conf / docker-compose.test.yml arrangement).
  //
  // The gateway strips the /esms prefix and forwards to esms-backend in the
  // esms namespace; onepact-lite is on the same gateway under /onepactlite.
  // The trailing /api is ours: unlike onepact, this app expects apiBaseUrl to
  // include it and appends only the resource path.
  apiBaseUrl: 'https://testapi.senkron.energy/esms/api',
  // See environment.ts for the contract. Empty = Entra sign-in disabled;
  // fill both in at build time to test corporate sign-in.
  azureAd: { clientId: '', tenantId: '' }
};
